import { Observer } from 'mobx-react';
import * as React from 'react';
import IdleTimer from 'react-idle-timer';
import { useOmnistore } from '../stores/Omnistore';

export const IdleLifecycle = (props: {}) => {
	const reoctoStore = useOmnistore().reoctoStore;
	const onActive = () => reoctoStore.setIsIdle(false);
	const onIdle = () => reoctoStore.setIsIdle(true);
	return <Observer>{
		() => <IdleTimer
			onActive={onActive}
			onAction={onActive}
			onIdle={onIdle}
			debounce={250}
			timeout={60 * 1000}/>
	}</Observer>;
};
